var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditionQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.30762,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#DFE1E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6142 17.1266C18.3258 17.3713 18.1164 17.7444 18.1164 18.2961C18.1164 18.6429 17.8353 18.924 17.4885 18.924C17.1417 18.924 16.8606 18.6429 16.8606 18.2961C16.8606 17.3827 17.2267 16.6569 17.8017 16.1691C18.363 15.6928 19.0891 15.4705 19.7908 15.4705C20.4925 15.4705 21.2186 15.6928 21.7799 16.1691C22.3549 16.6569 22.721 17.3827 22.721 18.2961C22.721 18.9373 22.5568 19.4259 22.2885 19.8283C22.0631 20.1664 21.7702 20.4278 21.5397 20.6335L21.4667 20.6988C21.2095 20.9303 21.0157 21.1211 20.8736 21.3721C20.7376 21.6122 20.628 21.9477 20.628 22.4821C20.628 22.8288 20.3469 23.11 20.0001 23.11C19.6533 23.11 19.3722 22.8288 19.3722 22.4821C19.3722 21.7607 19.5242 21.2066 19.7807 20.7534C20.0311 20.3111 20.3605 20.0048 20.6266 19.7654L20.687 19.711C20.9384 19.4853 21.1116 19.3298 21.2436 19.1316C21.3678 18.9454 21.4652 18.7014 21.4652 18.2961C21.4652 17.7444 21.2558 17.3713 20.9674 17.1266C20.6654 16.8703 20.2403 16.7263 19.7908 16.7263C19.3413 16.7263 18.9162 16.8703 18.6142 17.1266Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.475 26.2503C20.7071 25.9927 20.6864 25.5956 20.4287 25.3635C20.1711 25.1314 19.7741 25.1521 19.542 25.4098L19.5336 25.4191C19.3015 25.6767 19.3222 26.0738 19.5798 26.3059C19.8375 26.538 20.2345 26.5173 20.4666 26.2596L20.475 26.2503Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.8076C11 15.8371 15.0294 11.8076 20 11.8076C24.9705 11.8076 29 15.8371 29 20.8076C29 25.7781 24.9705 29.8076 20 29.8076C15.0294 29.8076 11 25.7781 11 20.8076ZM20 13.0634C15.723 13.0634 12.2558 16.5306 12.2558 20.8076C12.2558 25.0846 15.723 28.5518 20 28.5518C24.277 28.5518 27.7442 25.0846 27.7442 20.8076C27.7442 16.5306 24.277 13.0634 20 13.0634Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionQuestionMark);
export default __webpack_public_path__ + "static/media/condition_question_mark.3fc5cbd346b00ef1f2285d77d29910ca.svg";
export { ForwardRef as ReactComponent };